import { getDeviceInfo } from 'actionCreators/auth';
import { API_V4_BASE_URL } from 'settings';
import { post } from './api';

export const login = (token: string, courseHash: string) => {
  return post({
    url: '/oauth/eduzzaccount/validate',
    withCredentials: true,
    baseURL: API_V4_BASE_URL,
    data: { token, ...getDeviceInfo(), course_hash: courseHash },
  });
};
